import { render, staticRenderFns } from "./visit-record.pug?vue&type=template&id=2c003d80&lang=pug&"
import script from "./visit-record.ts?vue&type=script&lang=ts&"
export * from "./visit-record.ts?vue&type=script&lang=ts&"
import style0 from "./visit-record.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports